/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentLimitation extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("Limitation");
    }

    getFixupPrototypeFunction() { return ResponseForAgentLimitation.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentLimitation>): ResponseForAgentLimitation {
        let obj = Object.assign(new ResponseForAgentLimitation(), model);
        ResponseForAgentLimitation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentLimitation>): ResponseForAgentLimitation {
        if (!model) return null;
        return ResponseForAgentLimitation.newInstance(<ResponseForAgentLimitation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentLimitation) {
        if (!obj) return;

        models.ResponseForAgentLimitation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentLimitation): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentLimitation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Limitation response
     */
    value: Array<string>;

}
